import React, { useState } from "react";
import "../../css/privacy.scss";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const Privacy = () => {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <Header />
      <div className="privacy_main">
        <nav
          tabIndex={0}
          data-s-6bb43dea-7603-43e8-8d7a-82b639041e35=""
          className="fixed sd appear"
        >
          <a
            data-s-500e8cbd-7075-42af-9ce9-f236ce54d637=""
            href="#title1"
            data-r-0_2_500e8cbd-7075-42af-9ce9-f236ce54d637=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                1. 基本政策
              </font>
            </font>
          </a>
          <a
            data-s-94d05f11-19f1-4d38-aa63-06a443daef91=""
            href="#title2"
            data-r-1_2_94d05f11-19f1-4d38-aa63-06a443daef91=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                2. 适用范围
              </font>
            </font>
          </a>
          <a
            data-s-dbff8a52-6801-43da-9ad8-12ace6dcfed4=""
            href="#title3"
            data-r-2_2_dbff8a52-6801-43da-9ad8-12ace6dcfed4=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                3. 个人信息的获取
              </font>
            </font>
            <br />
          </a>
          <a
            data-s-57be42f2-cfbe-41c6-a698-16cf578485f2=""
            href="#title4"
            data-r-3_2_57be42f2-cfbe-41c6-a698-16cf578485f2=""
            className="text sd appear"
          >
            4．利用目的
            <br />
          </a>
          <a
            data-s-cdd794f0-c7f5-4b5d-81d6-f1a1d049761f=""
            href="#title5"
            data-r-4_2_cdd794f0-c7f5-4b5d-81d6-f1a1d049761f=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                5. 个人数据处理的委托
              </font>
            </font>
            <br />
          </a>
          <a
            data-s-86ae4e24-6134-4875-9bb7-25b647ca0eba=""
            href="#title6"
            data-r-5_2_86ae4e24-6134-4875-9bb7-25b647ca0eba=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                6. 个人数据处理的外包
              </font>
            </font>
            <br />
          </a>
          <a
            data-s-a9944074-0ab9-4f0a-82f5-0b480d4dcd08=""
            href="#title7"
            data-r-6_2_a9944074-0ab9-4f0a-82f5-0b480d4dcd08=""
            className="text sd appear"
          >
            7．第三者提供
            <br />
          </a>
          <a
            data-s-8c5f952e-59c1-427d-b1ba-737988225812=""
            href="#title8"
            data-r-7_2_8c5f952e-59c1-427d-b1ba-737988225812=""
            className="text sd appear"
          >
            8．共同利用
            <br />
          </a>
          <a
            data-s-bf87b172-ecb0-4f56-9065-c5bc8ab5e8b5=""
            href="#title9"
            data-r-8_2_bf87b172-ecb0-4f56-9065-c5bc8ab5e8b5=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                9. 个人数据安全管理
              </font>
            </font>
            <br />
          </a>
          <a
            data-s-eff856fb-b173-47f8-8477-c15d5f8f3ef3=""
            href="#title10"
            data-r-9_2_eff856fb-b173-47f8-8477-c15d5f8f3ef3=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                10. 披露和更正保留的个人数据
              </font>
            </font>
            <br />
          </a>
          <a
            data-s-73d6cb8f-b552-4b5d-a8f8-6a1490a3c658=""
            href="#title11"
            data-r-10_2_73d6cb8f-b552-4b5d-a8f8-6a1490a3c658=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                11. 将个人数据和个人信息用于广告分发
              </font>
            </font>
            <br />
          </a>
          <a
            data-s-f69b4033-00ab-4283-84ac-9118826f47b0=""
            href="#title12"
            data-r-11_2_f69b4033-00ab-4283-84ac-9118826f47b0=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                12. 应对事故
              </font>
            </font>
            <br />
          </a>
          <a
            data-s-20792026-17a6-4a99-931c-3c392297e584=""
            href="#title13"
            data-r-12_2_20792026-17a6-4a99-931c-3c392297e584=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                13. 本政策的变更
              </font>
            </font>
            <br />
          </a>
          <a
            data-s-c07cfd04-4614-416e-814f-5ce4727aa0e5=""
            href="#title14"
            data-r-13_2_c07cfd04-4614-416e-814f-5ce4727aa0e5=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                14. 接触点
              </font>
            </font>
            <br />
          </a>
          <a
            data-s-59ec51b0-b649-464c-bd2f-a7414e1664a7=""
            href="#title15"
            data-r-14_2_59ec51b0-b649-464c-bd2f-a7414e1664a7=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                15. 处理个人信息的企业信息
              </font>
            </font>
            <br />
          </a>
          <a
            data-s-51fa6a07-9c8e-4adf-914a-342413bee389=""
            href="#title16"
            data-r-15_2_51fa6a07-9c8e-4adf-914a-342413bee389=""
            className="text sd appear"
          >
            <font dir="auto" style={{ verticalAlign: "inherit" }}>
              <font dir="auto" style={{ verticalAlign: "inherit" }}>
                16. [GDPR隐私政策] 处理位于欧洲经济区的用户个人信息
              </font>
            </font>
            <br />
          </a>
        </nav>

        {/* main */}
        <div data-s-d2fee836-851e-444a-9836-16dc3fb23142="" className="sd">
          <div data-s-9e5ca5ca-4e7b-4dc1-90dd-06e925a68a5e="" className="sd">
            <p
              data-s-77ecf59c-0e8b-4410-8d4b-c49eb502ecc3=""
              data-r-0_0_3_77ecf59c-0e8b-4410-8d4b-c49eb502ecc3=""
              className="text sd appear"
            >
              Privacy
              <br />
            </p>
            <h1
              data-s-1d089a2f-966f-44fa-8566-23bab1eeb43a=""
              data-r-1_0_3_1d089a2f-966f-44fa-8566-23bab1eeb43a=""
              className="text sd appear"
            >
              プライバシーポリシー
            </h1>
          </div>
          <div
            data-s-022e5153-8af9-4984-817c-53d76d3587c6=""
            className="sd appear"
          >
            <div
              data-s-395a8a5e-3cb3-499d-820d-78f7c6c0070f=""
              className="sd appear"
            >
              <p
                data-s-9409b9ac-2ef2-4801-89ec-0348050c1d47=""
                data-r-0_0_1_3_9409b9ac-2ef2-4801-89ec-0348050c1d47=""
                className="text sd appear"
              >
                改定履歴
              </p>
              <p
                data-s-123b9001-8891-4dd2-8cdd-69fbf9ba9160=""
                data-r-1_0_1_3_123b9001-8891-4dd2-8cdd-69fbf9ba9160=""
                className="text sd appear"
              >
                2014年06月25日 制定・発効
                <br />
                2016年02月09日 改定
                <br />
                2016年11月17日 改定
                <br />
                2017年02月14日 改定
                <br />
                2019年05月24日 改定
                <br />
                2019年07月26日 改定
                <br />
                2020年12月18日 改定
                <br />
                2021年07月01日 改定
                <br />
                2022年03月28日 改定
                <br />
                2022年04月01日 改定
                <br />
                2022年07月20日 改定
                <br />
                2025年03月03日 改定
              </p>
            </div>
            <div
              data-s-1ff81ce5-06d3-482e-98f7-7eea2fa0b3f2=""
              className="sd appear"
            >
              <div
                data-s-7e5b8de6-31e7-4abe-8bec-dcbbffba67f7=""
                className="richText sd"
              >
                <p data-uid="A2EFc67J" data-time="">
                  　READYFOR株式会社（以下「当社」といいます。）は、当社が提供するサービス（以下「本サービス」といいます。）における個人情報の取扱いに関し、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。
                  <br />
                  　なお、本ポリシーにおける用語は、別途定める場合を除き、個人情報の保護に関する法律（平成15年法律第57号）において定義される意味によるものとします。
                </p>
              </div>
            </div>
            <div
              id="title1"
              data-s-f271fd99-afeb-4c60-a52e-0c5c43388656=""
              className="sd appear"
            >
              <div
                data-s-df959f2d-ae56-4703-ae12-9edcf2f29aa3=""
                className="richText sd"
              >
                <h2 data-uid="94qzQpaM" data-time="">
                  1．基本方針
                </h2>
                <p data-uid="NpijDhKC" data-time="">
                  　当社は、個人情報の重要性を認識し、個人情報を保護することが社会的責務であると考え、個人情報に関する法令及び社内規程等を遵守し、当社で取り扱う個人情報の取得、利用、管理を適正に行います。
                </p>
              </div>
            </div>
            <div
              id="title2"
              data-s-2576135b-9667-47a8-adf9-32513b321e2f=""
              className="sd appear"
            >
              <div
                data-s-db345143-695b-479a-994a-21598fb71e2c=""
                className="richText sd appear"
              >
                <h2 data-uid="1t8X8vP8" data-time="">
                  2．適用範囲
                </h2>
                <ol data-uid="3wM6x1ph" data-time="">
                  <li data-uid="LvJr_6hl" data-time="">
                    <p data-uid="c0MALayr" data-time="">
                      本ポリシーは、本サービスにおける個人情報の取扱いに関して定めるものです。
                    </p>
                  </li>
                  <li data-uid="g60JDcSp" data-time="">
                    <p data-uid="VJRTlW7n" data-time="">
                      本サービスからリンクされた当社の別サイト又は第三者のサイト及びサービスにおける個人情報の取扱いについては、本ポリシーは適用されません。
                      <br />
                      　当社は、第三者のサイトやサービスにおける個人情報の取扱いについてはいかなる義務や責任も負うものではありません。
                    </p>
                  </li>
                </ol>
              </div>
            </div>
            <div
              id="title3"
              data-s-3fc74bac-3948-4b7a-9d5b-e081af4ce4d5=""
              className="sd appear"
            >
              <div
                data-s-b5eb1d47-d979-4421-afc5-111321164f96=""
                className="richText sd appear"
              >
                <h2 data-uid="1t8X8vP8" data-time="">
                  3．個人情報の取得
                </h2>
                <ol data-uid="5Zbjc1tV" data-time="">
                  <li data-uid="d_Es47li" data-time="">
                    <p data-uid="K93kAk6U" data-time="">
                      当社は、本サービスに関連して個人情報を含む情報の送信を受けることなどにより、以下のような個人情報を取得する場合があります。
                      <br />
                      ・氏名又はユーザー名称
                      <br />
                      ・プロフィール画像
                      <br />
                      ・住所、メールアドレス、電話番号、所属先、銀行口座情報
                      <br />
                      ・ID、パスワードその他のアカウント情報
                      <br />
                      ・その他本サービスの利用に関する情報
                    </p>
                  </li>
                  <li data-uid="8N82myph" data-time="">
                    <p data-uid="KQVsOHXV" data-time="">
                      当社は、本サービスのユーザーのIPアドレス、ユーザーエージェント、Cookie情報、ユーザーの利用環境その他のユーザーの利用するブラウザから自動的に送信される情報を取得する場合があります。
                    </p>
                  </li>
                  <li data-uid="jqpiMzJo" data-time="">
                    <p data-uid="qJlEjezt" data-time="">
                      クレジットカード決済に必要な業務については、外部の決済代行会社であるGMOペイメントゲートウェイ株式会社に委託しております。当社は、「クレジットカード番号等」（割賦販売法35条の16第1項柱書）は一切保持しておりません。
                    </p>
                  </li>
                </ol>
              </div>
            </div>
            <div
              id="title4"
              data-s-1c16a9ab-0c19-42d7-94b3-bc97ec378784=""
              className="sd appear"
            >
              <div
                data-s-b7019713-6ed7-4203-81df-462645d6aae0=""
                className="richText sd appear"
              >
                <h2 data-uid="1t8X8vP8" data-time="">
                  4．利用目的
                </h2>
                <p data-uid="nZ_t4qaD" data-time="">
                  　当社は、本サービスにおいて取得した個人情報の利用目的を、以下のとおり特定します
                  <br />
                  　・本サービスの提供・実施（本サービスに関するお問合せに対する回答や、サービス利用契約上必要となる事項の対応を含みます。）
                  <br />
                  　・本サービスの改善、機能拡張その他の変更に向けた分析・検討
                  <br />
                  　・本サービスに関する連絡・メールマガジンその他の各種お知らせの配信
                  <br />
                  　・統計データの作成・分析その他マーケティング
                  <br />
                  　・新規サービスの検討・開発
                  <br />
                  　・当社又は第三者の商品・サービスの宣伝・広告
                  <br />
                  　・キャンペーン、アンケート、モニター、取材等の実施
                  <br />
                  　・ペイメントカード（クレジットカードなど）の不正利用等の詐欺行為の検知及び予防
                </p>
              </div>
            </div>
            <div
              id="title5"
              data-s-1849214c-9f7a-423f-ac7c-13cf08fea36d=""
              className="sd appear"
            >
              <div
                data-s-9024201b-c99d-4410-a75f-dfd7f09bf8c4=""
                className="richText sd appear"
              >
                <h2 data-uid="1t8X8vP8" data-time="">
                  5．個人データの取扱いの受託
                </h2>
                <p data-uid="JI0itwHI" data-time="">
                  　当社は、本サービスに関してユーザーから個人データの取扱いの委託を受けた場合、委託の目的の範囲内で、取扱いを委託された個人データを取り扱います。
                </p>
              </div>
            </div>
            <div
              id="title6"
              data-s-0d0c4674-338c-4e81-9c43-8ff7f1a75d28=""
              className="sd appear"
            >
              <div
                data-s-229d5a1f-96fd-439a-a74f-8ea735b47757=""
                className="richText sd appear"
              >
                <h2 data-uid="lC4UuMEa" data-time="" id="index_lC4UuMEa">
                  6．個人データの取扱いの委託
                </h2>
                <p data-uid="rmQ8FsdR" data-time="">
                  　当社は、本サービスに関して個人データの取扱いを決済代行会社その他の外部の第三者に委託する場合があります。
                  <br />
                  　この場合、当社は、取扱いを委託した個人データの安全管理が図られるよう、当該第三者に対して必要かつ適切な監督を行います。
                  <br />
                  　かかる委託に関し、外国にある第三者に対しても個人情報の取扱いを委託する場合があります。その詳細は以下のとおりです。
                </p>
                <p data-uid="TS3iAO8x" data-time="" />
                <h3 data-uid="zSjeVFa8" data-time="" id="index_zSjeVFa8">
                  不正利用検知のための個人データの提供
                </h3>
                <p data-uid="Cnbn1X4Y" data-time="">
                  　当社は、ペイメントカード（クレジットカードなど）の不正利用等の詐欺行為の検知及び予防を目的として、ユーザーの下記アの個人データを下記イの第三者にそれぞれ提供いたします。
                </p>
                <ol data-uid="xIYFBvIw" data-time="">
                  <li data-uid="ZYyPR5zA" data-time="">
                    <p data-uid="jM_ILaMI" data-time="">
                      Sift Science, Inc
                    </p>
                    <p data-uid="Y_1ovEHE" data-time="">
                      ア 提供する個人情報
                      <br />
                      ・ユーザーのメールアドレス
                      <br />
                      ・氏名
                      <br />
                      ・電話番号
                      <br />
                      ・請求先/配送先情報（氏名、住所、電話番号）
                      <br />
                      ・支払情報（支払手段、クレジットカード番号の一部等）
                      <br />
                      ・注文情報（商品名、数量等）
                      <br />
                      ・端末情報（IP アドレス、ユーザーエージェント等）
                      <br />
                      <br />イ 提供先
                      <br />
                      ・Sift Science, Inc（アメリカ合衆国カリフォルニア州）
                      <br />
                      ・宛先：Privacy Officer
                      <br />
                      ・123 Mission Street, 20th Floor, San Francisco, CA 94105
                      <br />
                      ・Email:{" "}
                      <Link onClick={toTop} to="mailto:privacy@sift.com">
                        privacy@sift.com
                      </Link>
                    </p>
                    <p data-uid="JVAz73eF" data-time="">
                      <br />
                      　提供先における個人情報の取扱いについては、Sift
                      のプライバシー方針 （Sift Service Privacy
                      Notice）をご確認下さい。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://sift.com/legal-and-compliance/service-privacy-notice"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://sift.com/legal-and-compliance/service-privacy-notice
                      </Link>
                      <br />
                      <br />
                      　提供先の所在国の個人情報の保護に関する制度については、下記リンク先をご確認下さい。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://www.ppc.go.jp/files/pdf/california_report.pdf"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://www.ppc.go.jp/files/pdf/california_report.pdf
                      </Link>
                    </p>
                  </li>
                  <li data-uid="6uJ_Ulmb" data-time="">
                    <p data-uid="E4Qlt_nC" data-time="">
                      クレジットカード発行会社
                    </p>
                    <p data-uid="seZl5ekn" data-time="">
                      ア 提供する個人情報
                      <br />
                      ・ユーザーのメールアドレス
                      <br />
                      ・クレジットカードの名義人等
                      <br />
                      <br />イ 提供先
                      <br />
                      ・ユーザーが利用するクレジットカード発行会社
                      <br />
                      <br />
                      　なお、ユーザーが利用するカード発行会社が外国にある場合、上記①の情報は当該発行会社が所属する国に移転される場合があります。当社では、ユーザーから収集した情報からは、ご利用のカード発行会社及び当該会社が所在する国を特定することができないため、以下の個人情報保護措置に関する情報を把握して、ご提供することはできません。
                    </p>
                    <p data-uid="4aWUBvJp" data-time="">
                      ・提供先が所在する外国の名称
                    </p>
                    <p data-uid="zk8l3Wat" data-time="">
                      ・当該国の個人情報保護制度に関する情報
                    </p>
                    <p data-uid="K8PA4Z1T" data-time="">
                      ・発行会社の個人情報保護の措置
                    </p>
                    <p data-uid="7lpH19u1" data-time="">
                      <br />
                      　なお、個人情報保護委員会のホームページでは、各国における個人情報保護制度に関する情報について掲載されています。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://www.ppc.go.jp/"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://www.ppc.go.jp/
                      </Link>
                      <br />
                    </p>
                  </li>
                </ol>
              </div>
            </div>
            <div
              id="title7"
              data-s-5542b609-9e99-48f3-9d29-3e5405188429=""
              className="sd appear"
            >
              <div
                data-s-9060a60d-6a96-4530-a058-a091f62d4feb=""
                className="richText sd appear"
              >
                <h2 data-uid="_FbwoWUp" data-time="">
                  7．第三者提供
                </h2>
                <ol data-uid="e8JwRDYb" data-time="">
                  <li data-uid="HGXxUA2f" data-time="">
                    <p data-uid="QWdh4_I2" data-time="">
                      当社は、本ポリシー又は本サービスの関係規約上で別途定める場合や、以下に定める場合を除き、あらかじめ本人の同意を得ないで、第三者に対して個人データを提供しません
                      <br />
                      ・法令に基づく場合
                      <br />
                      ・人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき。
                      <br />
                      ・公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき。
                      <br />
                      ・国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき。
                      <br />
                      ・個人情報取扱事業者が利用目的の達成に必要な範囲内において個人データの取扱いの全部又は一部を委託することに伴って当該個人データが提供される場合
                      <br />
                      ・合併その他の事由による事業の承継に伴って個人データが提供される場合
                    </p>
                  </li>
                  <li data-uid="5MGdmkpA" data-time="">
                    <p data-uid="uGvPgfRt" data-time="">
                      なお、当社は、本サービスの説明、宣伝・広告等を目的として、当社が取得した情報、データ等をユーザーを識別できない状態（統計資料等）で情報を利用又は開示する場合があります。
                    </p>
                  </li>
                </ol>
              </div>
            </div>
            <div
              id="title8"
              data-s-3c1b307d-dfaf-4654-a97c-f4f30b498d36=""
              className="sd appear"
            >
              <div
                data-s-8fd8177c-3a4c-4bd4-b50f-f93bc81cac66=""
                className="richText sd appear"
              >
                <h2 data-uid="_FbwoWUp" data-time="">
                  8．共同利用
                </h2>
                <p data-uid="V_cCK181" data-time="">
                  　当社は、本サービスにおいて取得した個人データの共同利用を行っておりません。今後、共同利用を行うこととした場合、本ポリシーの中で公表する方法その他適切な方法により公表いたします。
                </p>
              </div>
            </div>
            <div
              id="title9"
              data-s-b2646744-30f3-4cd5-a920-86f6370a0dab=""
              className="sd appear"
            >
              <div
                data-s-2470101c-198a-4431-accf-099c9e09223e=""
                className="richText sd appear"
              >
                <h2 data-uid="2U2Jrdye" data-time="">
                  9．個人データの安全管理等
                </h2>
                <p data-uid="XMzguCBp" data-time="">
                  　当社は、利用目的の達成に必要な範囲内において、個人データを正確かつ最新の内容に保つとともに、利用する必要がなくなったときは、当該個人データを遅滞なく消去するよう努めます。
                  <br />
                  　また、当社は、個人データへの不正アクセス、個人情報の紛失、滅失、毀損、改ざん、漏えいなどを防止するため、当社所定の「
                  <Link onClick={toTop} to="/privacy">
                    情報セキュリティ方針
                  </Link>
                  」に則り、セキュリティシステムの維持・管理体制の整備・従業員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行います。
                </p>
              </div>
            </div>
            <div
              id="title10"
              data-s-ebf67946-e8cc-4754-a604-fdfa16f723d8=""
              className="sd appear"
            >
              <div
                data-s-e6a93e66-6516-44de-a5dc-7b05556b3a99=""
                className="richText sd appear"
              >
                <h2 data-uid="1fnNeRBT" data-time="">
                  10．保有個人データの開示・訂正等
                </h2>
                <p data-uid="b2AclNW4" data-time="">
                  　当社は、保有個人データについて、法令に従い、本人又はその代理人からの利用目的の通知、開示、変更等（内容の訂正、追加又は削除）、利用停止等（利用の停止又は消去）、第三者への提供の停止の求めに対応させていただいております。これらをご希望される場合、末尾のお問合せ先までご連絡下さい。
                </p>
              </div>
            </div>
            <div
              id="title11"
              data-s-5d123ac7-d619-4090-aa68-1badb2105768=""
              className="sd appear"
            >
              <div
                data-s-a32ee455-83e4-447c-b8c2-321cd70ca0c3=""
                className="richText sd appear"
              >
                <h2 data-uid="Fd9VVk8F" data-time="">
                  11．広告配信に関する個人データ・個人関連情報の活用
                </h2>
                <ol data-uid="MxP94ioI" data-time="">
                  <li data-uid="6aJvzH8s" data-time="">
                    <p data-uid="OYlrF1us" data-time="">
                      ユーザーの関心に合わせた広告配信のための提供
                      <br />ア
                      当社は、ユーザーの関心に合わせた広告の提供を行うため、広告の効果測定、広告配信精度の向上（当社ユーザーと属性の共通する者に対する広告配信など）を目的としてイに記載する外部サービスを利用し、その提供事業者に対し、ユーザーのメールアドレス
                      や、ユーザーごとに当社が設定するユーザーID、クッキーその他のアクセス情報を提供し、
                      又はその取扱いを委託する場合があります。
                      <br />
                      <br />
                      ・クッキーとは
                      <br />
                      　ユーザーが該当のウェブサイトにアクセスした際に、ユーザーのコンピュータ内に記憶させておく文字列情報のことで、特定のユーザー個人を識別できる情報は含まないものをいいます。ユーザーはブラウザの設定を変更することにより、クッキーの送受信を拒否することができます。
                      <br />
                      <br />イ
                      当社の利用する外部事業者のサービス及びこれに関する以下のとおりです。クッキ
                      ーの送受信の拒否や特定の広告サービスへの情報提供を停止したい場合は、下記の各企業のサイトにアクセスし、所定のオプトアウト手続を行ってください。
                      <br />
                      <br />
                      ①Google 関連の広告サービス
                      <br />
                      ・GoogleRecommendationsAI、GoogleAnalytics を含みます。
                      <br />
                      ・提供事業者による情報利用に関するポリシーについては以下をご確認ください。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://policies.google.com/technologies/partner-sites?hl=ja"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://policies.google.com/technologies/partner-sites?hl=ja
                      </Link>
                      <br />
                      ・オプトアウト手続に関しては以下をご確認ください。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://tools.google.com/dlpage/gaoptout?hl=ja"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://tools.google.com/dlpage/gaoptout?hl=ja
                      </Link>
                      <br />
                      ・提供事業者の所在国（アメリカ合衆国カリフォルニア州）における個人情報保護に関する制度は以下のとおりです。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://www.ppc.go.jp/files/pdf/californiareport.pdf"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://www.ppc.go.jp/files/pdf/california
                        <u>report.pdf</u>
                      </Link>
                      <br />
                      <u>
                        <br />
                      </u>
                      ②Meta（Facebook、Instagram）関連の広告サービス
                      <u>
                        <br />
                      </u>
                      ・提供事業者による情報利用に関するポリシーについては以下をご確認ください。
                      <u>
                        <br />
                      </u>
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://www.facebook.com/policy.php"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://www.facebook.com/policy.php
                      </Link>
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://www.facebook.com/help/instagram/155833707900388"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://www.facebook.com/help/instagram/155833707900388
                      </Link>
                      <br />
                      ・オプトアウト手続に関しては以下をご確認ください。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://www.facebook.com/help/109378269482053"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://www.facebook.com/help/109378269482053
                      </Link>
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://help.instagram.com/519522125107875/?mayberedirectpol=0"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://help.instagram.com/519522125107875/?mayberedirectpol=0
                      </Link>
                      <br />
                      ・提供事業者の所在国（アメリカ合衆国カリフォルニア州）における個人情報保護に
                      関する制度は以下のとおりです。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://www.ppc.go.jp/files/pdf/californiareport.pdf"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://www.ppc.go.jp/files/pdf/californiareport.pdf
                      </Link>
                      <br />
                      <br />
                      ③Yahoo!関連の広告サービス
                      <br />
                      ・提供事業者による情報利用に関するポリシーについては以下をご確認ください。{" "}
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://about.yahoo.co.jp/common/terms/chapter1/#cf2nd"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://about.yahoo.co.jp/common/terms/chapter1/#cf2nd
                      </Link>
                      <br />
                      ・オプトアウト手続に関しては以下をご確認ください。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://btoptout.yahoo.co.jp/optout/index.html"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://btoptout.yahoo.co.jp/optout/index.html
                      </Link>
                      <br />
                      ・提供事業者は日本に所在しております。
                      <br />
                      <br />
                      ④LINE 関連の広告サービス
                      <br />
                      ・提供事業者による情報利用に関するポリシーについては以下をご確認ください。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://line.me/ja/terms/policy/"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://line.me/ja/terms/policy/
                      </Link>
                      <br />
                      ・オプトアウト手続に関しては以下をご確認ください。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="http://optout.fivecdm.com/"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        http://optout.fivecdm.com/
                      </Link>
                      <br />
                      ・提供事業者は日本に所在しております。
                      <br />
                      <br />
                      ⑤Criteo 広告サービス
                      <br />
                      ・提供事業者による情報利用に関するポリシーについては以下をご確認ください。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://www.criteo.com/jp/privacy/"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://www.criteo.com/jp/privacy/
                      </Link>
                      <br />
                      ・オプトアウト手続に関しては以下をご確認ください。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://www.criteo.com/jp/privacy/disable-criteo-services-on-internet-browsers/"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://www.criteo.com/jp/privacy/disable-criteo-services-on-internet-browsers/
                      </Link>
                      <br />
                      ・提供事業者はフランスに所在しており、法令上個人情報保護委員会の告示（下記リンク先）により、同国の個人情報保護制度は日本と同等の水準にあると認められてお
                      ります。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://www.ppc.go.jp/files/pdf/190123h31iinkaikokuji01.pdf"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://www.ppc.go.jp/files/pdf/190123h31iinkaikokuji01.pdf
                      </Link>
                      <br />
                      <br />
                      ⑥RTB House 広告サービス
                      <br />
                      ・提供事業者による情報利用に関するポリシーについては以下をご確認ください。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://www.rtbhouse.com/rtbhouse-paperflite-privacy-policy/"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://www.rtbhouse.com/rtbhouse-paperflite-privacy-policy/
                      </Link>
                      <br />
                      ・オプトアウト手続に関しては以下をご確認ください。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://optout.rtbhouse.com/jp/"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://optout.rtbhouse.com/jp/
                      </Link>
                      <br />
                      ・提供事業者はイギリスに所在しており、個人情報保護委員会の告示（下記リンク先）により法令上、同国の個人情報保護制度は日本と同等の水準にあると認められております。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://www.ppc.go.jp/files/pdf/190123h31iinkaikokuji01.pdf"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://www.ppc.go.jp/files/pdf/190123h31iinkaikokuji01.pdf
                      </Link>
                    </p>
                  </li>
                  <li data-uid="X486pfzs" data-time="">
                    <p data-uid="I_LU2MsX" data-time="">
                      個人関連情報の取得について
                      <br />
                      当社は、第三者と提携して行う広告の効果測定等を目的として、当該第三者より当社が
                      出稿した広告へのクリックに係る情報（クリック日時、遷移元
                      URL、ご使用の機器や OS
                      に関する情報等）等の個人関連情報を取得し、当社において保有するデータと紐づけて個
                      人データとして利用する場合があります。
                    </p>
                  </li>
                </ol>
              </div>
            </div>
            <div
              id="title12"
              data-s-73bb776e-7abc-4554-8057-65cdd91e28ba=""
              className="sd appear"
            >
              <div
                data-s-ebc6ea88-3bbe-449b-b07a-4b3a60fd4be9=""
                className="richText sd appear"
              >
                <h2 data-uid="uk5DGaVx" data-time="">
                  12．事故への対応
                </h2>
                <p data-uid="jNSiRYSJ" data-time="">
                  　個人データの漏えい等の事故が発生した場合、当社は、関係法令に則り、個人情報保護
                  委員会への報告や本人への通知・公表を行うとともに、その指示に従い、再発防止措置等
                  の必要な対応を行います。
                </p>
              </div>
            </div>
            <div
              id="title13"
              data-s-c8495114-cd30-4da8-a7da-51bb678b833b=""
              className="sd appear"
            >
              <div
                data-s-02fe94d8-04fc-4724-b49e-3600d29afc9e=""
                className="richText sd appear"
              >
                <h2 data-uid="IwKKg34i" data-time="">
                  13．本ポリシーの変更
                </h2>
                <p data-uid="QOZngG3T" data-time="">
                  　当社は、個人情報の取扱いに関する運用を適宜見直し、必要に応じて本ポリシーの全部又は一部を変更する場合があります。当社が本ポリシーを変更した場合、本サービスを通じて変更後の内容を公表します。この場合、ユーザーの個人情報は、変更後のプライバシーポリシーに従って取り扱われることになります。
                </p>
              </div>
            </div>
            <div
              id="title14"
              data-s-0a31ec6e-e6ee-458e-b7bd-9629aef7b9ef=""
              className="sd appear"
            >
              <div
                data-s-41b34585-7f91-4b92-bf05-1ff9d9d7325f=""
                className="richText sd appear"
              >
                <h2 data-uid="K6gpxFxh" data-time="">
                  14．お問い合わせ窓口
                </h2>
                <p data-uid="bwLe3Tt_" data-time="">
                  　本サービスに関する個人情報の取扱いに関するご意見、ご質問、異議・苦情のお申出その他のお問合せは、下記窓口までお願いいたします。
                </p>
                <p data-uid="55PApdiX" data-time="" />
                <p data-uid="zpzxzBps" data-time="">
                  ■個人情報管理責任者
                </p>
                <p data-uid="Gi2Dwz8z" data-time="">
                  東京都千代田区一番町8　住友不動産一番町ビル7階
                </p>
                <p data-uid="5OvFUG0_" data-time="">
                  READYFOR株式会社
                </p>
                <p data-uid="xrEOataz" data-time="">
                  個人情報保護管理責任者
                </p>
                <p data-uid="CVkk3MKb" data-time="">
                  Email:&nbsp;
                  <Link
                    onClick={toTop}
                    target="_blank"
                    to="mailto:privacy@readyfor.jp"
                    data-has-link="true"
                    rel="noreferrer"
                  >
                    privacy@readyfor.jp
                  </Link>
                </p>
                <p data-uid="tqUkqIYx" data-time="" />
                <p data-uid="hla5yh1o" data-time="">
                  ■請求手続きのご案内は
                  <Link onClick={toTop} to="/">
                    こちら
                  </Link>
                </p>
              </div>
            </div>
            <div
              id="title15"
              data-s-535df4dc-261d-49ea-85cc-9367b9d87300=""
              className="sd appear"
            >
              <div
                data-s-ec604151-e8ed-4ca3-bc05-e9a2dd1585f1=""
                className="richText sd appear"
              >
                <h2 data-uid="mv0WFm1D" data-time="">
                  15．個人情報取扱事業者の情報
                </h2>
                <ul data-uid="bTULboIS" data-time="">
                  <li data-uid="TFNCDR_B" data-time="">
                    <p data-uid="hOhzn9ML" data-time="">
                      名称：READYFOR 株式会社
                    </p>
                  </li>
                  <li data-uid="enS_fV3b" data-time="">
                    <p data-uid="3b1xlRlm" data-time="">
                      住所：東京都千代田区一番町 8 住友不動産一番町ビル 7 階
                    </p>
                  </li>
                  <li data-uid="nhSWYhbo" data-time="">
                    <p data-uid="A5s2Q3he" data-time="">
                      代表者：代表取締役 CEO 米良はるか
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div
              id="title16"
              data-s-1b1c8205-37da-43fd-bc6e-790935f7bb26=""
              className="sd appear"
            >
              <div
                data-s-67908424-24b7-4bb7-b2ab-b579e9865c17=""
                className="richText sd appear"
              >
                <h2 data-uid="mv0WFm1D" data-time="">
                  16．【GDPRプライバシーポリシー】欧州経済領域内に所在のユーザーの個人情報の取り扱い
                </h2>
                <p data-uid="8vOneASC" data-time="">
                  　EU加盟国、ノルウェー、アイスランド及びリヒテンシュタインから成る欧州経済領域（以下、これらの国を総称して「EEA」といいます）の域内に所在するユーザーの個人情報の取扱いに関しては、EU一般データ保護規則（"REGULATION
                  OF THE EUROPEAN PARLIAMENT AND OF THE COUCIL on the protection
                  of natural persons with regard to the processing of personal
                  data and on the free movement of such data, and repealing
                  Directive
                  95/46/EC”、以下「GDPR」といいます。）に基づき、上記プライバシーポリシーに加えて本項の規定が適用されます。なお、上記プライバシーポリシーで規定する内容に本項で規定する内容が抵触する場合には、本項の規定が優先するものとします。
                </p>
                <ol data-uid="qdKqbdxb" data-time="">
                  <li data-uid="ng4Iilm_" data-time="">
                    <p data-uid="hPg5QS_2" data-time="">
                      はじめに
                      <br />
                      本方針は、当社が、EEA域内に所在の方（以下「データ主体」といいます）から個人データの提供若しくは開示を受けた場合又は第三者を通じて個人データの受領若しくは取得をした場合に、当社が管理者として当該個人データをどのように収集し、処理するかについてデータ主体に説明するものです。
                    </p>
                  </li>
                  <li data-uid="q0F4GADB" data-time="">
                    <p data-uid="fHB1vbEJ" data-time="">
                      個人情報の取扱い
                      <br />
                      当社がユーザーの個人情報を取り扱う方法及び目的、当社が取り扱うユーザーの個人情報の種類、ならびにユーザーの個人情報の第三者提供につきましては、第1項（基本方針）から第9項（個人データの安全管理等）に記載した通りです。
                    </p>
                  </li>
                  <li data-uid="MXEpdw4B" data-time="">
                    <p data-uid="KTwC9Wbl" data-time="">
                      法的根拠
                      <br />
                      当社における個人情報の利用は、原則としてユーザー本人の同意をその法的根拠としています。ユーザー本人の同意がない場合における個人情報の利用は、ユーザーとの契約の履行のための必要性、契約締結前のユーザーの求めに応じた手続の実行のための必要性、当社もしくは第三者によって求められる正当な利益のための必要性、又は当社が従うべき法的義務を遵守するための必要性をその法的根拠としています。当社又は第三者によって求められる正当な利益には、マーケティング及びサービスの改善等による利益の増加等、ならびに当社ウェブサイトの利便性及びセキュリティの向上等が該当します。
                    </p>
                  </li>
                  <li data-uid="o1qZioJ8" data-time="">
                    <p data-uid="nwxi0_1B" data-time="">
                      個人情報の取扱いに関する請求について
                    </p>
                    <p data-uid="OtB1_l1O" data-time="">
                      当社は、EEA域内に所在のユーザーの個人情報に関するご請求に対し、第4項（利用目的）・第10項（保有個人データの開示・訂正等）に加え、合理的な期間及び範囲で、次のとおり対応します。なお、ご請求にあたっては、事前に本人様確認をさせて頂きます。
                      <br />
                      <br />
                      ・同意の撤回に関するご請求
                      <br />
                      　ご請求内容を確認の上、適切かつ可能な範囲で、ユーザーの個人情報に関する内容の削除又は利用停止を行います。なお、利用停止又は削除により、それまでご利用可能だったサービス、あるいはユーザーのご要望に沿ったサービスの提供ができなくなる場合があります。あらかじめご了承の上、ご請求ください。
                      <br />
                      <br />
                      ・データポータビリティに関するご請求
                      <br />
                      　ご請求内容を確認の上、適切かつ可能な範囲で、ユーザー本人が希望された個人情報の受け渡し、又は受け取りを行います。
                      <br />
                      <br />
                      ・個人情報の利用の制限に関するご請求
                      <br />
                      　ご請求内容を確認の上、適切かつ可能な範囲で、ユーザー本人が希望された手続きを行います。
                      <br />
                      <br />
                      ・異議申し立てに関するご請求
                      <br />
                      　ご請求内容を確認の上、適切かつ可能な範囲で、ユーザー本人の個人情報の利用を停止します。
                      <br />
                      <br />
                      ・請求方法
                      <br />
                      　ユーザーは、上記第14項記載の「お問い合わせ窓口」に連絡することにより、本項の権利を行使することができます。
                    </p>
                  </li>
                  <li data-uid="6whT9XLO" data-time="">
                    <p data-uid="IBoaWwke" data-time="">
                      EEA域外へのデータ移転について
                    </p>
                    <p data-uid="LSUs9Yqb" data-time="">
                      当社は、取得した個人データについて、EEA域外の第三国への国際移転を行わなければならない場合、国際データ移転のために必要となる適切な保護措置を講じます。なお、当社の各種事業のマーケティング、営業活動又はサービス提供を行うにあたり、海外事業者が提供するサーバを利用する場合があります。
                    </p>
                  </li>
                  <li data-uid="8ZNheCek" data-time="">
                    <p data-uid="d6w0GgYq" data-time="">
                      16歳未満の本人について
                    </p>
                    <p data-uid="O7lnthgd" data-time="">
                      EEA域内に所在の方で16歳未満の、又は加盟国法に基づく年齢制限に達しないユーザーにおかれましては、当社のサービス・その他をご利用するにあたり、保護者の方に同意を行って頂くか、同意に対して保護者の方の許可をいただくようお願いいたします。ユーザー本人に代わって当社のサービスをご利用お申込み・入力等を行う方におかれましても、当社による個人情報の取扱いについて、ユーザー本人の同意を得てお申込み頂きますようお願いいたします。
                    </p>
                  </li>
                  <li data-uid="5td7g69C" data-time="">
                    <p data-uid="3eHxVZfs" data-time="">
                      個人データの保存期間
                    </p>
                    <p data-uid="hwQCvqbn" data-time="">
                      当社は、ユーザーから取得・収集した個人データについて、上記に記載している目的に従い、必要な期間中、これを保管・管理いたします。当社は、個人データが、上記に記載しております目的に照らし、必要でなくなりましたら、速やかに個人データを削除する方針です。
                    </p>
                  </li>
                  <li data-uid="gqOqNpoS" data-time="">
                    <p data-uid="OGuW303E" data-time="">
                      プロファイリングを含む自動化された意思決定の不存在
                    </p>
                    <p data-uid="hXE2NATv" data-time="">
                      当社は、当社サイトのアクセスログを分析することはありますが、ご提供いただいた個人情報を用いたデータ主体の個人的嗜好や行動などを分析、予測するための自動化された処理（プロファイリング含む）や、データ主体に法的な影響を与える意思決定を行うようなことはありません。
                    </p>
                  </li>
                  <li data-uid="YsydxDvX" data-time="">
                    <p data-uid="4_QpzKWF" data-time="">
                      監督機関への不服申立てについて
                    </p>
                    <p data-uid="Rlew96yY" data-time="">
                      関連する個人情報の処理につき、ユーザーは、ユーザー本人の居住地を管轄するデータ保護当局に対して異議を申し立てる権利を有します。各国のデータ保護当局は以下のURLから確認することが可能です。
                      <br />
                      <Link
                        onClick={toTop}
                        target="_blank"
                        to="https://ec.europa.eu/newsroom/article29/items/612080"
                        data-has-link="true"
                        rel="noreferrer"
                      >
                        https://ec.europa.eu/newsroom/article29/items/612080
                      </Link>
                    </p>
                  </li>
                  <li data-uid="nELDR6cG" data-time="">
                    <p data-uid="ghcZDCmA" data-time="">
                      お問い合わせ窓口
                    </p>
                    <p data-uid="F3E8VpJu" data-time="">
                      本項「4.個人情報の取扱いに関する請求について」の問合せ先は第14項（お問い合わせ窓口）記載のとおりです。
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Privacy;
